import styled from 'styled-components';
import { Link as Router } from 'react-router-dom';
import { Card } from 'react-bootstrap';

export const Container = styled.div`
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 20px;
  padding-right: 20px;
  ::-webkit-scrollbar-track {
    background-color: #f1f9ff;
  }
  ::-webkit-scrollbar {
    width: 0px;
    background: #f1f9ff;
  }
  ::-webkit-scrollbar-thumb {
    background: #f1f9ff;
  }
`;

export const UserResponsive = styled.div`
  @media (max-width: 1099px) {
    display: block;
  }
`;

export const PageTitle = styled.h1`
  color: #f0b01b;
  margin-top: 1.5rem;
  margin-bottom: 21px;
  font-size: 1.5rem;
`;

export const ShortcutContainer = styled.div`
  width: auto;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ShortcutLink = styled(Router)`
  text-decoration: none !important;
  margin-right: 20px;
`;

export const Shortcut = styled(Card)`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  border: 0;
  border-radius: 0;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: ${props => (props.selected ? '#074f8c' : '#ffffff')};
  cursor: ${props => (props.selected ? 'default' : 'pointer')};
  width: 130px;
  height: 115px;
  transition: 0.5s color;
  @media (max-width: 1150px) {
    margin-top: -2px;
    width: 120px;
    height: 105px;
  }
  @media (max-width: 440px) {
    width: 90px;
    height: 75px;
  }
  @media (max-width: 350px) {
    width: 80px;
    height: 65px;
  }
`;

export const ShortcutIcon = styled.span`
  color: ${props => (props.selected ? '#ffffff' : '#074f8c')};
  font-size: 1.8em;
  margin-top: -8px;
  @media (max-width: 440px) {
    font-size: 1.4em;
  }
  @media (max-width: 350px) {
    font-size: 1.3em;
  }
`;

export const ShortcutText = styled.span`
  color: ${props => (props.selected ? '#ffffff' : '#808495')};
  text-align: center;
  font-size: 0.9em;
  @media (max-width: 440px) {
    font-size: 0.7em;
  }
  @media (max-width: 350px) {
    font-size: 0.6em;
  }
`;

export const Scrollbar = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  ::-webkit-scrollbar-track {
    background-color: #f1f9ff;
  }
  ::-webkit-scrollbar {
    width: 6px;
    background: #f1f9ff;
  }
  ::-webkit-scrollbar-thumb {
    background: #f1f9ff;
  }
  height: 82vh;
  @media (min-width: 1920px) {
    overflow-y: hidden !important;
  }
  @media (max-width: 1100px) {
    height: 90vh;
  }
  @media (max-width: 440px) {
    height: 80vh;
  }
`;

export const TipContainer = styled.div`
  background-color: #ffffff;
  box-shadow: 0px 3px 6px #0000001a;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 15px;
`;

export const Tip = styled.span`
  color: #818181;
  font-size: 13px;
`;

export const Hr = styled.hr`
  border-color: #c1c1c1;
  border-style: dashed;
  margin: 10px 0px 20px 0px;
`;

export const Title = styled.h1`
  font-size: 24px;
  color: ${({ theme }) => theme.colors.blue};
  font-weight: bold;
  margin-top: 15px;

  @media (min-width: 768px) {
    display: ${props => (props.mobile ? 'none' : 'block')};
  }

  @media (max-width: 768px) {
    margin-top: 20px;
    display: ${props => (props.desktop ? 'none' : 'block')};
  }
`;
